<template>
  <div>
    <div v-if="!unclosable" class="d-flex align-center">
      <v-spacer></v-spacer>
      <div v-if="!maps_open" style="color: grey; font-size: 10px;">
        Näytä kartat
      </div>
      <v-btn @click="SET_MAPS_OPEN(!maps_open)" v-tooltip="!maps_open ? 'Näytä kartat' : 'Piilota kartat'" text x-small>
        <v-icon v-if="maps_open">mdi-chevron-down</v-icon>
        <v-icon v-else>mdi-chevron-up</v-icon>
      </v-btn>
    </div>
    <!-- {{ uniqueMapBaseIds }} -->

    <!-- {{ map_bases }} -->
    <!-- {{ opened_map_type }} -->
    <div v-show="maps_open" style="min-height: 220px;">
      <DynamicMap
        @eventClicked="handleEventClicked"
        :key="openedMap.id"
        v-if="map_bases && map_bases.length && openedMap"
        :image_url="openedMap.url"
        :objects="currentMapPoints"
        ref="dynamicMap"
        :showOnMobile="true"
      ></DynamicMap>
      <!-- {{ openedMap }} -->
      <div v-if="['msu', 'nsu'].includes(currentLeagueName)" class="d-flex justify-center my-3">
        <v-btn :color="openedMap && openedMap.map_type === 'field' ? 'primary' : ''" @click="SET_OPENED_MAP_TYPE('field')" text x-small>Lyönnit</v-btn>
        <v-btn :color="openedMap && openedMap.map_type === 'plate' ? 'primary' : ''" @click="SET_OPENED_MAP_TYPE('plate')" text x-small class="ml-2">Väärät</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
// import { pointFromEvent } from '@/utils/filter/pointFromEvent'
import DynamicMap from '@/components/maps/DynamicMap.vue';

export default {
  props: ['unclosable'],
  components: {
    DynamicMap
  },
  data: () => ({
    mapKey: 0,
  }),
  async created() {
    await this.initLeagueMapBases({ league_id: this.leagueId })
  },
  computed: {
    ...mapGetters('filter', ['allFilteredEvents', 'allFilteredEvents', 'uniqueMapBaseIds', 'opened_map_type', 'maps_open', 'currentMapPoints']),
    ...mapGetters('map', ['map_bases']),
    ...mapGetters('user', ['leagueId', 'currentLeagueName']),
    openedMap() {
      this.opened_map_type
      return this.map_bases.find(p => p.map_type === this.opened_map_type)
    }
  },
  methods: {
    ...mapActions('map', ['initLeagueMapBases']),
    ...mapActions('filter', ['openEvent']),
    ...mapMutations('filter', ['SET_OPENED_MAP_TYPE', 'SET_MAPS_OPEN']),
    // getMapBases(newVal) {
    //   alert(newVal)
    // }
    handleEventClicked(eventId) {
      const e = this.allFilteredEvents.find(e => e.event_id === eventId)
      this.openEvent(e)
    },
    download() {
      this.$refs.dynamicMap.downloadImage()
    }
  }
}
</script>